// extracted by mini-css-extract-plugin
export default {"famImage":"personal_famImage__mxnma","famImage1":"personal_famImage1__1O5Kx"};